import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  buttonIcon: {
    '& path': {
      fill: theme.palette.text.primary,
    },
  },
  selectedItemIcon: {
    height: '20px',
    width: '20px',
    flex: 'none',
    '& path': {
      stroke: theme.palette.primary.main,
    },
  },
  menuToggleIcon: {
    minWidth: 16,
    paddingRight: '4px', // visually align with toggle of nav menu items
  },
  disabled: {
    opacity: 0.5,
  },
  buttonBase: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px',
    borderRadius: '8px',
    width: '100%',
    textAlign: 'left',
    whiteSpace: 'break-spaces',
    backgroundColor: theme.new.color.common.white,
    '&:hover': {
      backgroundColor: theme.new.color.brand[100],
    },
    '&:focus-visible': {
      outlineOffset: '1px',
      outline: `2px auto ${theme.new.color.textPrimary}`,
    },
  },
  buttonBaseMenuOpen: {
    backgroundColor: theme.new.color.brand[200],
    '&:hover': {
      backgroundColor: theme.new.color.brand[200],
    },
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '32px',
    minWidth: '32px',
    backgroundColor: theme.new.color.grey[200],
    borderRadius: '4px',
  },
  expandedContainer: {
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  selectableListItem: {
    borderRadius: '8px',
    whiteSpace: 'break-spaces',
    '&:focus-visible': {
      backgroundColor: 'white',
    },
  },
  rootListItem: {
    position: 'sticky',
    top: 0,
    zIndex: 2,
    flex: 1,
  },
  subContextListItem: {
    margin: '0 20px',
    '&::before': {
      content: '""',
      position: 'absolute',
      left: '-12px',
      top: 0,
      bottom: 0,
      borderLeft: `1px solid ${theme.new.color.grey[300]}`,
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      left: '-12px',
      top: '50%',
      width: '8px',
      borderTop: `1px solid ${theme.new.color.grey[300]}`,
      transform: 'translateY(-50%)',
    },
    '&:last-of-type': {
      '&::before': {
        height: '50%',
      },
    },
  },
  menuList: {
    '& .MuiButtonBase-root.MuiMenuItem-root': {
      '&.Mui-selected': {
        backgroundColor: theme.new.color.common.white,
      },
      '&:hover': {
        backgroundColor: theme.new.color.brand[100],
      },
      '&:focus-visible': {
        outlineOffset: '-1px',
        outline: `2px auto ${theme.new.color.brand[600]}`,
      },
    },
  },
  fleetSwitcherContainer: {
    margin: '16px 0px',
    padding: '0px 8px',
  },
  popper: {
    borderRadius: '12px',
    boxShadow: theme.new.boxShadows.elevation2,
    zIndex: theme.zIndex.drawer + 1,
  },
  paper: {
    width: '320px',
    zIndex: theme.zIndex.drawer + 1,
    padding: '8px',
    overflow: 'hidden',
  },
  scrollBox: {
    maxHeight: '400px',
    overflowY: 'auto',
  },
  staticFleetSwitcherContainer: {
    margin: '16px 0px',
    padding: '0px 8px',
    cursor: 'default',
  },
  staticFleetSwitcherContent: {
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px',
    borderRadius: '8px',
    width: '100%',
    textAlign: 'left',
    whiteSpace: 'break-spaces',
  },
  staticIconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '32px',
    minWidth: '32px',
    backgroundColor: theme.new.color.grey[200],
    borderRadius: '4px',
  },
  staticExpandedContent: {
    width: '100%',
  },
  listItemText: {
    color: theme.new.color.text.primary,
  },
  selectedListItemText: {
    color: theme.new.color.brand[600],
  },
}));

export default useStyles;
